import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ILoginModal } from "./interface";
import "./LoginModal.scss";
import { useState } from "react";
import { authorizationService } from "../../api_services/authorizationService";
import { alertService } from "../Services/alertService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../Utils/Utils";

const LoginModal = (props: ILoginModal) => {
    const { onClose, setHandleConfigJSON, setGotJSONFlag, type, postInput, jsonType } = props;
    const [inputs, setInputs] = useState<any>({});
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);
    let payLoad: any = getURLDataMethod();
    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }

    const handleConfigJson = async () => {
        if (payLoad) {
            const payloadData: any = JSON.parse(JSON.stringify(payLoad));;
            const dev_Id = payLoad['device_id'];
            const device = payLoad['device_type'].split('iLens-')[1];
            const auth = 'Basic ' + btoa(inputs?.username + ':' + inputs?.password);
            let headers: any = {
                "headers": {
                    'Device-Id': dev_Id,
                    'File-Type': jsonType,
                    'Authorization': auth,
                    "X-Requested-With": "XMLHttpRequest"
                }
            };
            if (postInput) {
                payloadData["data"] = JSON.parse(postInput);
                try {
                    return await authorizationService.handleConfigJson("handleConfigJson", payloadData, device, payloadData['firmware_version'], headers).then((res: any) => {
                        if (res.status === 200) {
                            if (res.body) {
                                onClose && onClose(false);
                                alertService.serviceSuccessMessage(res?.body?.message)
                            }
                        }
                        else if (res.response?.status === 401) {
                            endSession()
                        }
                        else if (res.response?.status === 403) {
                            noAccessMessage(res.response?.data?.message)
                        }
                        else {
                            alertService.serviceErrorMessage(res?.body?.message)
                            console.log("error");
                        }
                    })
                } catch (err: any) {
                    console.log(err);
                }
            }
        }
    }
    const getJson = async () => {
        if (payLoad) {
            const payload = JSON.parse(JSON.stringify(inputs));
            const dev_Id = payLoad['device_id'];
            const device = payLoad['device_type'].split('iLens-')[1];
            const auth = 'Basic ' + btoa(inputs?.username + ':' + inputs?.password);
            let headers: any = {
                "headers": {
                    'Device-Id': dev_Id,
                    'File-Type': jsonType,
                    'Authorization': auth,
                    "X-Requested-With": "XMLHttpRequest"
                }
            };
            try {
                return await authorizationService.getJsonData("handleConfigJson", payload, device, payLoad['firmware_version'], headers).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body.data))
                            setHandleConfigJSON && setHandleConfigJSON(JSON.stringify(res.body.data, null, 4));
                            setGotJSONFlag && setGotJSONFlag(true)
                            onClose && onClose(false);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }

    }
    const submitForm = () => {
        setSubmitFlag(true);
        if (inputs?.username && inputs?.password) {
            if (type === "post") {
                handleConfigJson();
            }
            else {
                getJson();
            }
        }
    }
    return (
        <div className="login-modal">
            <div className="modal fade show d-block" tabIndex={1} role="dialog" aria-hidden="true" >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header login-header">
                            <div>
                                <span id="header" className="modal-title w-100"> LOG IN </span>
                            </div>
                            <div className="font-icon" onClick={() => { onClose && onClose(false) }}>
                                <FontAwesomeIcon icon={faTimes} className="mx-1 menu-link-hoverable pointer" data-dismiss="modal" />
                            </div>
                        </div>
                        <div className="modal-body login-modal-body pt-3 pb-0 events-none">
                            <div>
                                <input
                                    type="username"
                                    name="username"
                                    value={inputs?.username ? inputs?.username : ""}
                                    placeholder="User ID"
                                    className="form-control login-input my-3"
                                    autoComplete="nope"
                                    onChange={handleChange}
                                />
                                {submitFlag && !inputs?.username &&
                                    <div className="text-danger m-2">Please Enter Username</div>
                                }
                            </div>
                            <div>
                                <input
                                    type="password"
                                    name="password"
                                    value={inputs?.password ? inputs?.password : ""}
                                    placeholder="Password"
                                    className="form-control login-input my-3"
                                    autoComplete="new-password"
                                    onChange={handleChange}
                                />
                                {submitFlag && !inputs?.password &&
                                    <div className="text-danger m-2">Please Enter Password</div>
                                }
                            </div>
                        </div>
                        <div className="no-border-footer modal-footer justify-content-center pt-0 login-modal-footer" >
                            <button attr-test="modal-submit" type="button" className="btn btn-log  w-100" onClick={submitForm}>{type === "post" ? "Log In to Save" : "Log In"}</button>
                            <button attr-test="modal-submit" type="button" className="btn btn-close w-100" onClick={() => { onClose && onClose(false) }}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </div>
    )
}
export default LoginModal;